import { selectSubassignmentManagementState } from 'modules/subassignmentManagement/store/selectors';
import { IStore } from 'store/configureStore';

export const selectIsPlacementChangeOpened = (state: IStore) =>
    selectSubassignmentManagementState(state).placementChange.isOpenPlacementChangeModal;
